import Header from './components/Header';
import Hero from './components/Hero';
import MarqueeFeed from './components/MarqueeFeed';
import TrendingList from './components/TrendingList';
import TopicFlow from './components/TopicFlow';
import CommentArena from './components/CommentArena';
import CommunityPanel from './components/CommunityPanel';
import TrustFaq from './components/TrustFaq';
import JoinCta from './components/JoinCta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Header />
      <main className="w-full flex-1">
        <Hero />
        <MarqueeFeed />
        <TrendingList />
        <TopicFlow />
        <CommentArena />
        <CommunityPanel />
        <TrustFaq />
        <JoinCta />
      </main>
      <Footer />
    </div>
  );
}